import FilterRegister from "../../../../components/filter/register-basic";
import reqCredenciais from "../../../../services/reqMultiTenant/reqCredenciais";
import { RegisterProvider } from "../../../register/register-matrix/context-api";
import MainRegisterMatrix from "../../../register/register-matrix/main";
import FormCredenciais from "../form";

const MainAdminCredenciais = () => {
	const options = {
		id: "id_credenciais",
		ident: "adminCredenciais",
		identFilter: "filterAdminCredenciais",
		title: "Credenciais de API",
		subTitle: "Administração",
		tableColumns: [
			{ key: "descricao", label: "Descrição", align: "left" },
			{ key: "url", label: "URL do servidor", align: "left" },
			{ key: "obs", label: "Observação", align: "left" },
			{ key: "actions", label: "", align: "right" },
		],
		hasActive: true,
		parametersFilter: [{ id: 1, label: "Descrição", value: "descricao" }],
	};

	const fetch = async (filterData, newPage) => {
		const { param, paramValue, active } = filterData;

		const response = await reqCredenciais.listPaginate(param, paramValue, active, newPage);

		return response;
	};

	const fetchID = async (currentId) => {
		const response = await reqCredenciais.listID(currentId);

		return response;
	};

	const insert = async (data) => {
		const response = await reqCredenciais.insert(data);

		return response;
	};

	return (
		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert}>
			<MainRegisterMatrix FormComponent={FormCredenciais} FormFilter={FilterRegister} />
		</RegisterProvider>
	);
};

export default MainAdminCredenciais;
